// import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { WebCourseFormValues } from "src/models/WebCourse.model";

type Props = {
  formikProps: FormikProps<WebCourseFormValues>;
  onClose: () => void;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};

const WebCourseForm = ({
  formikProps,
  onClose,
  formType,
  setSaveNextChecked,
  saveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 overflow-hidden">
      <div className="flex items-center justify-between h-fit">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Web Course" : "Update Web Course"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4">
        {/* Student name */}
        <ATMTextField
          required
          name="courseName"
          value={values?.courseName}
          onChange={(e) => setFieldValue("courseName", e.target.value)}
          label=" Course Name"
          placeholder="Enter Course Name"
          onBlur={handleBlur}
        />

      </div>

      <div className="h-fit">
        {formType === "Add" && (
          <div>
            <ATMCheckbox
              label="Save and Next"
              checked={saveNextChecked}
              onChange={(checked) => {
                setSaveNextChecked(checked);
              }}
            />
          </div>
        )}
        <div>
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default WebCourseForm;
